import { ActivatedRouteSnapshot } from '@angular/router';

/** Walks the route tree for `projectID` (supports nested `project/:projectID/...` routes). */
export function getProjectIdFromRoute(route: ActivatedRouteSnapshot): string | null {
  let current: ActivatedRouteSnapshot | null = route;
  while (current) {
    const projectID = current.paramMap.get('projectID');
    if (projectID) {
      return projectID;
    }
    current = current.parent;
  }
  return null;
}
